module.exports = __webpack_public_path__ + "static/media/pumpLogo.03d9b90d.svg";